import { NDfs } from '../dfs.interfaces';

export function dfsString2Dimension(str: string): NDfs.IDimension {
    // 0 is an exception of unitless thing
    if (str === '0' || !str) {
        return { value: 0, unit: 'px' };
    }
    // split qty an unit
    const result = str.match(/(-?\d+)((\w|%)+)?/);
    if (!result) {
        throw new Error('Invalid measure: ' + str);
    }
    // generate css value
    return { value: Number(result[1]), unit: result[2] || 'q' };
}
